import portalCollection from '@shopgate/pwa-common/helpers/portals/portalCollection';
import { lazy } from 'react';

const ShopgateStorefrontCartHidePaypalExpress = lazy(() => import('@shopgate/storefront/frontend/portals/CartHidePaypalExpress'))

const ShopgateConnectTrustedGuestCheckoutLink = lazy(() => import('@shopgate/connect-trusted/frontend/GuestCheckout/portals/RegisterLinkAfter/index.jsx'))

const ShopgateConnectTrustedGuestCheckoutLogout = lazy(() => import('@shopgate/connect-trusted/frontend/GuestCheckout/portals/NavMenuLogout/index.jsx'))

portalCollection.registerConfig({
 "@shopgate/storefront/CartHidePaypalExpress": {
  "path": "@shopgate/storefront/frontend/portals/CartHidePaypalExpress",
  "target": "legacy-paypal-express.cart"
 },
 "@shopgate/connect-trusted/GuestCheckoutLink": {
  "path": "@shopgate/connect-trusted/frontend/GuestCheckout/portals/RegisterLinkAfter/index.jsx",
  "target": "page.login.register-link.after"
 },
 "@shopgate/connect-trusted/GuestCheckoutLogout": {
  "path": "@shopgate/connect-trusted/frontend/GuestCheckout/portals/NavMenuLogout/index.jsx",
  "target": "nav-menu.logout"
 }
});

portalCollection.registerPortals({
  '@shopgate/storefront/CartHidePaypalExpress': ShopgateStorefrontCartHidePaypalExpress,
  '@shopgate/connect-trusted/GuestCheckoutLink': ShopgateConnectTrustedGuestCheckoutLink,
  '@shopgate/connect-trusted/GuestCheckoutLogout': ShopgateConnectTrustedGuestCheckoutLogout,
});
